import * as React from 'react'
import { useCallback, useEffect } from 'react'
import { ClosedWonQueueLink } from '@user/components/SoldServices/ClosedWonQueueLink/ClosedWonQueueLink'
import { useSelector } from 'react-redux'
import { SoldServiceList } from './SoldServiceList/SoldServiceList'
import { SoldServiceStatusSelect } from './SoldServiceStatusSelect'
import { styles } from './styling'
import {
  selectAllClosedWonQueueSubmissions,
  selectClosedWonQueueSubmissionsSettings,
  setPage,
} from '@user/store/dashboard/widgets/closedWonQueueSubmissions/slice'
import { getClosedWonQueueSubmissions } from '@user/store/dashboard/widgets/closedWonQueueSubmissions/api'
import { SOLD_SERVICE_STATUS } from '@sales-center/common'
import { useAppDispatch } from '@user/store/hooks'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Pagination from '@mui/material/Pagination'

import {
  IUserPreferenceGeneralListItemType,
  saveGeneralPreferences,
  userGeneralPreferencesList,
} from '@user/store/userPreferences/userPreferencesGeneral'

export function ContentFront() {
  const dispatch = useAppDispatch()
  const opps = useSelector(selectAllClosedWonQueueSubmissions)
  const { page, count, isLoading, take } = useSelector(
    selectClosedWonQueueSubmissionsSettings,
  )

  const userGeneralPreferences = useSelector(userGeneralPreferencesList)

  const filterValue =
    userGeneralPreferences?.find(
      (row) =>
        row?.type ===
        IUserPreferenceGeneralListItemType.CloseWonQueueSubmissionsWidgetFilter,
    )?.value ?? SOLD_SERVICE_STATUS.Revise

  const fetchData = useCallback(
    (pageNumber: number, queryValue: string) => {
      dispatch(setPage(pageNumber))
      dispatch(
        getClosedWonQueueSubmissions({
          page: pageNumber,
          query: queryValue === 'ALL' ? '' : queryValue,
        }),
      )
      if (queryValue !== filterValue) {
        dispatch(
          saveGeneralPreferences({
            type: IUserPreferenceGeneralListItemType.CloseWonQueueSubmissionsWidgetFilter,
            value: queryValue,
          }),
        )
      }
    },
    [dispatch, filterValue],
  )

  const handleStatusChange = useCallback(
    (status: string) => {
      fetchData(1, status)
    },
    [fetchData],
  )

  // only for initial render, after that user can change filter and page with select and pagination components
  useEffect(() => {
    fetchData(page, filterValue)
  }, [])

  return (
    <Box>
      <Box sx={styles.select}>
        <SoldServiceStatusSelect
          filterValue={filterValue}
          onChange={handleStatusChange}
        />
      </Box>
      <Box>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <SoldServiceList opportunities={opps} />
        )}
      </Box>
      {count / take > 1 && (
        <Box sx={styles.pagination} display="flex" justifyContent="flex-end">
          <Pagination
            count={Math.ceil(count / take)}
            color="primary"
            size="small"
            onChange={(_e, pageNumber) => {
              fetchData(pageNumber, filterValue)
            }}
            page={page}
            style={{ display: 'flex' }}
          />
        </Box>
      )}
      <Box sx={styles.closedWonQueueLink}>
        <ClosedWonQueueLink marginRight={0} />
      </Box>
    </Box>
  )
}
